// Always enable likes analytics; no env flag gate.
export const ANALYTICS_LIKES_ENABLED = true;

export const ensureAnalyticsSessionId = () => {
  try {
    if (typeof window !== "undefined") {
      if (!window.__analyticsSessionId) {
        const generator =
          window.crypto && typeof window.crypto.randomUUID === "function"
            ? () => window.crypto.randomUUID()
            : null;
        window.__analyticsSessionId = generator
          ? generator()
          : `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      }
      return window.__analyticsSessionId;
    }
  } catch (e) {
    console.warn("Falling back to ad-hoc session id", e);
  }
  return `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};
